module.exports = "/_next/static/images/Mobile-Header-Image-10031bb3abd13c2b8bb09d7591b00eef.jpg";